import { Injectable } from '@angular/core';
import { IDatosGenerales, IDatosGeneralesCompras } from '../models/IDatosGenerales';
import { ITotalizerTile } from '../components/totalizer-tiles/ITotalizerTile'
import { IEvColumn } from '../components/lcv-ev-column-chart/IEvColumn'
import { IGraphDis, IGraphEv, IResponseCalculos } from '../models/IResponseCalculos';
import { ITotalStats } from '../models/ITotalStats';


@Injectable({
  providedIn: 'root'
})
export class LcvDataMapperService {

  constructor() { }

  public mapDatosGrales(datosGenerales: IDatosGenerales, selectedToggle: string): ITotalizerTile[] {
    let tileArray: ITotalizerTile[] = []
    
    tileArray.push({
      icon: "fa fa-calculator",
      title: "Monto Total",
      isAmount: true,
      value: datosGenerales.montoTotal
    });
    tileArray.push({
      icon: "fa fa-credit-card-alt",
      title: selectedToggle == "COMPRA"? "Cantidad de Proveedores" : "Cantidad de Clientes",
      isAmount: false,
      value: datosGenerales.cantidadRutDoc
    });
    tileArray.push({
      icon: "fa fa-usd",
      title: "Monto Promedio",
      isAmount: true,
      value: datosGenerales.montoTotalPromedio
    });

    return tileArray;
  }

  public mapEvGraph(evData: IGraphEv, years: string[]): Map<string, IGraphEv> {

    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril',
      'Mayo', 'Junio', 'Julio', 'Agosto',
      'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    let seriesMap = new Map<string, IGraphEv>();
    years.forEach((year) =>{
      let filteredValues: number[] = [];
      let columns: IEvColumn[] = [];
      
      for (const [index, categoria] of evData.categorias.entries()) {
        let splittedMonth = categoria.split('-');
        if (splittedMonth.length < 2) { continue }
        
        const month = splittedMonth[0];
        const elementYear = splittedMonth[1];
        
        if (year == elementYear) {
          // monthNumbers.push(parseInt(month, 10) - 1)
          // filteredValues.push(evData.values[index])
          

          columns.push({
            month: parseInt(month, 10) - 1,
            year: elementYear,
            value: evData.values[index]
          })
        }
      }
      let filteredCategories: string[] = [];
      
      for (const [index, monthName] of months.entries()) {
        let column = columns.find(obj => obj.month === index);
        filteredCategories.push(monthName);
        if (column) {
          filteredValues.push(column.value);
        } else {
          filteredValues.push(0);
        }
      }
  
      let graph = {
        categorias: filteredCategories,
        values: filteredValues
      }

      seriesMap.set(year, graph);
    })

    // console.log(seriesMap)
    return seriesMap;
  }

  public mapByPropertyGraph() {
    
  }

  public mapTotalStats(compra: IResponseCalculos, venta: IResponseCalculos, mesesParam: string, periodoActualParam: string): ITotalStats {
    const datosVenta = venta?.datosGenerales;
    const datosCompra = compra?.datosGenerales;

    const meses: string = mesesParam || '36';
    
    const totalVentasFactura: number = datosVenta?.montoTotalFacturas || 0;
    const totalVentas: number = datosVenta?.montoTotalNoNotaCredito || 0;
    const totalVentasNC: number = datosVenta?.montoTotalNotaCredito || 0;
    const totalVentasMonto: number = (totalVentas - totalVentasNC) || 0;
    
    const porcVentasFacturas: number = (totalVentasFactura / totalVentasMonto) * 100;
    const cantVentas: number = datosVenta?.totalRegistros || 0;
    const ventasPromedio: number = (totalVentasMonto / cantVentas);
    
    const montoTotalCompra: number = datosCompra?.montoTotalNoNotaCredito || 0;
    const totalComprasNC: number = datosCompra?.montoTotalNotaCredito || 0;
    const totalComprasMonto: number = (montoTotalCompra - totalComprasNC) || 0;
    const totalCompras: number = datosCompra?.totalRegistros || 0;
    const compraPromedio: number = (totalComprasMonto / totalCompras);

    const margen: number = (totalVentasMonto - totalComprasMonto);

    const porcVentasNC: number = (totalVentasNC / totalVentasMonto)  * 100;

    const periodoActual = periodoActualParam;
    const periodoAnterior = (Number(periodoActual) - 1).toString();
    const ventaTotalAnioActual = venta?.graphDisPorAnio?.[periodoActual] || 0;
    const ventaTotalAnioAnterior = venta?.graphDisPorAnio?.[periodoAnterior] || 0;
    const porcCrecVentasUltimoAnio: number = ((ventaTotalAnioActual - ventaTotalAnioAnterior) / ventaTotalAnioAnterior) * 100;

    const totalVentasBoleta: number = datosVenta?.montoTotalBoletas || 0;
    const porcVentasBoletas: number = (totalVentasBoleta / totalVentasMonto) * 100;

    const nClientes: number = datosVenta?.cantidadRutDoc || 0;
    const nProveedores: number = datosCompra?.cantidadRutDoc || 0;

    const margenPromedio: number = (totalVentasMonto - totalComprasMonto) / Number(meses);

    const ventaTotalUltimoMes: number = datosVenta?.montoTotalMesReciente || 0;
    const ventaTotalMesAnterior: number = datosVenta?.montoTotalMesAnterior || 0;

    const porcCrecVentasUltimoMes: number = ((ventaTotalUltimoMes - ventaTotalMesAnterior) / ventaTotalMesAnterior) * 100;

    return {
      porcVentasFacturas: {name: "% Ventas con facturas", value: this.validaInfinito(porcVentasFacturas)},
      porcVentasBoletas: {name: "% Ventas con Boletas", value: this.validaInfinito(porcVentasBoletas)},
      ventasPromedio: {name: "Venta Promedio", value: this.validaInfinito(ventasPromedio)},
      nClientes: {name: "N° Clientes", value: this.validaInfinito(nClientes)},
      compraPromedio: {name: "Compra Promedio", value: this.validaInfinito(compraPromedio)},
      nProveedores: {name: "N° Proveedores", value: this.validaInfinito(nProveedores)},
      margen: {name: "Margen", value: this.validaInfinito(margen)},
      margenPromedio: {name: "Margen Promedio", value: this.validaInfinito(margenPromedio)},
      porcVentasNC: {name: "% NC sobre ventas", value: this.validaInfinito(porcVentasNC)},
      ventaUltimoMes: {name: "Venta Ultimo Mes", value: this.validaInfinito(ventaTotalUltimoMes)},
      ventaAnioActual: {name: "Ventas año Actual", value: this.validaInfinito(ventaTotalAnioActual)},
      porcCrecVentasUltimoMes: {name: "% Crecimiento Ventas ultimo mes", value: this.validaInfinito(porcCrecVentasUltimoMes)},
      porcCrecVentasUltimoAnio: {name: "% Crecimiento ventas vs año anterior", value: this.validaInfinito(porcCrecVentasUltimoAnio)},
    }
  }


  validaInfinito(valor: number): number | string {
    return (isFinite(valor) ? (valor || 0) : (''));
  }

  mapGraphDis(data: IGraphDis[]): IGraphEv {
    let categories: string[] = []
    let values: number[] = []

    data.forEach((element: IGraphDis) => {
      categories.push(element.nombre);
      values.push(element.montoK);
    })

    return {
      categorias: categories,
      values: values
    }
  }

  generarTablaTop10Proveedores(datosCompras: IGraphDis[]): IGraphDis[] {
    return datosCompras.sort((a, b) => b.monto - a.monto);
  }
}



